import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useMemo, useState } from 'react';
import { PopoverAnchor } from '@radix-ui/react-popover';
import { Command as CommandPrimitive } from 'cmdk';
import { Check, LoaderCircle } from 'lucide-react';
import { cn } from '../../utils';
import { Command, CommandEmpty, CommandGroup, CommandItem, CommandList, } from '../Command';
import { Input } from '../Input';
import { Popover, PopoverContent } from '../Popover';
export function AutoComplete({ selectedValue, onSelectedValueChange, searchValue, onSearchValueChange, items, isLoading, emptyMessage = 'No items.', placeholder = 'Search...', }) {
    const [open, setOpen] = useState(false);
    const labels = useMemo(() => items.reduce((acc, item) => {
        acc[item] = item;
        return acc;
    }, {}), [items]);
    const reset = () => {
        onSelectedValueChange('');
        onSearchValueChange('');
    };
    const onSelectItem = (inputValue) => {
        if (inputValue === selectedValue) {
            reset();
        }
        else {
            onSelectedValueChange(inputValue);
            onSearchValueChange(labels[inputValue] ?? '');
        }
        setOpen(false);
    };
    return (_jsx("div", { className: "flex items-center", children: _jsx(Popover, { open: open, onOpenChange: setOpen, children: _jsxs(Command, { shouldFilter: false, children: [_jsx(PopoverAnchor, { asChild: true, children: _jsx(CommandPrimitive.Input, { asChild: true, value: selectedValue || searchValue, onValueChange: (e) => {
                                onSearchValueChange(e);
                                onSelectedValueChange('');
                            }, onKeyDown: (e) => setOpen(e.key !== 'Escape'), onMouseDown: () => setOpen((open) => !!searchValue || !open), onFocus: () => setOpen(true), children: _jsx(Input, { placeholder: placeholder, onBlur: (e) => {
                                    onSelectedValueChange(e.target.value);
                                } }) }) }), !open && _jsx(CommandList, { "aria-hidden": "true", className: "hidden" }), _jsx(PopoverContent, { asChild: true, onOpenAutoFocus: (e) => e.preventDefault(), onInteractOutside: (e) => {
                            if (e.target instanceof Element &&
                                e.target.hasAttribute('cmdk-input')) {
                                e.preventDefault();
                            }
                        }, className: cn('w-[--radix-popover-trigger-width] p-0', isLoading && 'overflow-hidden'), children: _jsxs(CommandList, { children: [isLoading && (_jsx(CommandPrimitive.Loading, { children: _jsx("div", { className: "p-1", children: _jsx(LoaderCircle, { className: "animate-spin h-6 w-full", color: "#007bff" }) }) })), items.length > 0 && !isLoading ? (_jsx(CommandGroup, { children: items.map((option) => (_jsxs(CommandItem, { className: "items-start gap-2", value: option, onMouseDown: (e) => e.preventDefault(), onSelect: onSelectItem, children: [selectedValue === option && (_jsx(Check, { className: cn('h-6 w-6 mt-1', selectedValue === option
                                                    ? 'opacity-100'
                                                    : 'opacity-0') })), _jsx("span", { className: "text-wrap break-all", children: option })] }, option))) })) : null, !isLoading ? (_jsx(CommandEmpty, { children: emptyMessage ?? 'No items.' })) : null] }) })] }) }) }));
}
